<!-- This gets the files from the API and displays them -->
<template>
  <div class="animated fadeIn">
    <b-alert v-for="(error, index) in errors" variant="danger" dismissible :show="showError"
             @dismissed="dismissErrors(index)">
      <div><strong>ERROR:</strong> {{ error.message }} </div>
    </b-alert>

    <b-card header="<i class='icon-folder'></i> Files">

      <paginate name="files" :list="files" tag="div" class="paginate-list" :per="20">
        <table class="table table-sm" v-if="files !== null && files.length !== 0">
          <thead>
          <tr>
            <th></th>
            <th>Date</th>
            <th>File</th>
            <th>Size</th>
          </tr>
          </thead>
          <tbody>

          <tr v-for="file in paginated('files')">
            <td>
              <button class="btn btn-primary btn-micro" @click="downloadFile(file)">Download</button>
            </td>
            <td>{{ file.uploadTime | moment("MM/DD/YYYY HH:mm:ss") }}</td>
            <td><a href="#" @click="downloadFile(file)">{{ file.description }}</a></td>
            <td>{{ file.size | prettyBytes(2) }}</td>
          </tr>
          </tbody>
        </table>

      </paginate>

      <paginate-links
        for="files"
        :limit="2"
        :show-step-links="true"
        v-if="files !== null && files.length !== 0"
        :classes="{
    'ul': ['pagination', 'justify-content-center']
  }"
      ></paginate-links>

      <div v-if="files !== null && files.length === 0">No Files Found</div>
      <div v-if="files === null && errors.length === 0">
        Loading File List <img :src="require('../assets/spinner.svg')" width="25em" height="25em">
      </div>

    </b-card>
  </div>
</template>

<script>
  import { BACKEND_SERVICE } from '../http-common-service'

  export default {
    name: 'GetFiles',
    data () {
      return {
        errors: [],
        files: null,
        paginate: ['files'],
        userid: this.$store.state.cognito.user.username
      }
    },
    created () {
      this.getFileList()
    },
    computed: {
      showError () {
        return this.errors.length > 0
      }
    },

    methods: {
      dismissErrors (index) {
        this.errors.splice(index, 1)
        if (!this.files && !this.errors.length) {
          this.getFileList()
        }
      },
      generateDownloadUrl (file) {
        return file.url
      },
      downloadFile (file) { // Download file from server
        BACKEND_SERVICE({
          method: 'get',
          url: 'scms/v1/users/' + this.userid + '/files/' + file.id,
          responseType: 'arraybuffer',
          headers: { 'Authorization': 'bearer ' + this.$store.state.cognito.user.tokens.IdToken }
        })
          .then(function (response) {
            let blob = new Blob([response.data], { type: file.mimeType })
            if (window.navigator.msSaveOrOpenBlob) { // stupid IE
              window.navigator.msSaveOrOpenBlob(blob, file.filename)
            } else if (navigator.userAgent.match('CriOS')) { // stupider Chrome iOS
              let reader = new FileReader()
              reader.onload = function (e) {
                window.location.href = reader.result
              }
              reader.readAsDataURL(blob)
            } else { // most browsers can use FileReader but stupid Chrome Desktop
              let link = document.createElement('a')
              let url = window.URL.createObjectURL(blob)
              link.href = url
              link.download = file.filename
              document.body.appendChild(link)
              link.click()
              setTimeout(function () {
                document.body.removeChild(link)
                window.URL.revokeObjectURL(url)
              }, 100)
            }
          })
          .catch(e => {
            this.errors.push(e)
            console.log(this.errors)
            this.$raven.captureException(e)
          })
      },
      getFileList () { // Download file list from server
        BACKEND_SERVICE.get('scms/v1/users/' + this.userid + '/files?allAccounts=true', {
          headers: { 'Authorization': 'bearer ' + this.$store.state.cognito.user.tokens.IdToken }
        })
          .then(response => {
            this.files = response.data.sort((a, b) => { return a.id - b.id }).reverse()
            this.errors = []
          })
          .catch(e => {
            this.errors.push(e)
            console.log(this.errors)
            this.$raven.captureException(e)
          })
      }
    }
  }
</script>

<style scoped>
  .btn-micro {
    padding: 0.1rem 0.3rem;
    font-size: 0.79rem;
    line-height: 1.5;
  }
</style>



// WEBPACK FOOTER //
// src/views/GetFiles.vue?fcf527c2